import { MovieOffIcon } from './MovieOffIcon';

/**
 * author: Colton Wiscombe
 * id 2260571C-D9DD-4720-AFB7-C54A32585767
 * name movie-off
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-off.svg
 * tags
 * - Video / Movie 
 */
export const SlateOffIcon = MovieOffIcon;
export default SlateOffIcon